import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { appInsightsConfig } from '../env';

// We need to keep the same interface as the ApplicationInsights object to avoid errors
var appInsights = { trackEvent: () => {} };

if (
  window.cookieyes &&
  window.getCkyConsent &&
  window.getCkyConsent().categories.analytics
) {
  appInsights = new ApplicationInsights({
    config: {
      ...appInsightsConfig,
      enableCorsCorrelation: true,
    },
  });

  const telemetryInitializer = (envelope) => {
    envelope.data.Tags = 'UI016-Frontend';

    // Extract trace context from response headers if available
    const traceId = document
      .querySelector('meta[name="trace-id"]')
      ?.getAttribute('content');
    const spanId = document
      .querySelector('meta[name="span-id"]')
      ?.getAttribute('content');

    if (traceId && spanId) {
      envelope.tags['ai.operation.id'] = traceId;
      envelope.tags['ai.operation.parentId'] = spanId;
    }
  };

  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer(telemetryInitializer);
  appInsights.trackPageView();
}

export { appInsights };
